import moment from 'moment';

export const formatDate = (expirationTime) => {
  if (expirationTime) {
    const formattedDate = moment(expirationTime).format('DD/MM/YY');
    return formattedDate;
  } else {
    return 'No Expiration';
  }
};

export function formatPhone(p) {
  if (p && p.length === 12) {
    return `${p.substring(0, 3)} ${p.substring(3, 6)} ${p.substring(
      6,
      9,
    )} ${p.substring(9, 12)}`;
  }
  if (p && p.length === 10) {
    return `${p.substring(0, 4)} ${p.substring(4, 7)} ${p.substring(7, 10)}`;
  } else {
    return p;
  }
}
export function formatMedicare(p) {
  if (p && p.length === 10) {
    return `${p.substring(0, 4)} ${p.substring(4, 9)} ${p.substring(9, 10)}`;
  } else {
    return p;
  }
}

export function formatNumberString(str) {
  return str.replace(/(\d{4})(?=\d)/g, '$1 ');
}

export const formatMhrSyncTime = (lastSync) => {
  if (!lastSync) {
    return 'No MHR sync available. This is either a new patient or missing details needed for a MHR sync.';
  }
  const timeDifference = new Date() - new Date(lastSync);
  const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);

  let formatted = `${days} day${days > 1 ? 's' : ''}, `;
  formatted += `${hours} hour${hours > 1 ? 's' : ''}, `;
  formatted += `${minutes} minute${minutes > 1 ? 's' : ''}`;
  return 'Last sync: ' + formatted + ' ago';
};

export const formatUserData = (data, field) => {
  const dataKey = field.title.toLowerCase().replace(' ', '_');
  const dataArray = data[`usr_${dataKey}`];

  if (!dataArray || dataArray.length === 0) {
    return '-';
  }

  const sortedData = dataArray.sort(
    (a, b) => moment(b.event_date).valueOf() - moment(a.event_date).valueOf(),
  );

  const mostRecent = sortedData[0];
  const value = mostRecent.value_quantity.value;
  const unit = mostRecent.value_quantity.unit;
  const date = moment(mostRecent.event_date).format('DD MMM YYYY');

  return (
    <>
      {value}
      {unit} <span style={{ color: '#888' }}>({date})</span>
    </>
  );
};

export const getScale = (height) => {
  if (height > 8000) return 0.6;
  if (height > 7000) return 0.65;
  if (height > 6000) return 0.7;
  if (height > 5000) return 0.75;
  if (height > 4000) return 0.8;
  return 0.85;
};
